"use client";
import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import { useInViewEffect } from "react-hook-inview";
import { useState } from "react";
import { ITheme } from "@/api/AppApi/services/company/interfaces/ICompany";
import { getProductBoxDefaultDimAndSpacing } from "../../common/functions";
import useSellingMode from "@/hooks/useSellingMode";
import EnableSellingTooltip from "./EnableSellingTooltip";
import { ProductBoxContextProvider } from "../context/ProductBoxContext";
import { IProductMinimizedData } from "@/app/components/pages-components/product-details-page/details-belpers/product-attributes/helpers/interfaces";
import {
  ProductPreviewTypes,
  unit,
} from "@/api/AppApi/services/product/interfaces/api-product-details-interface";

interface Props {
  size: Size;
  scrollableTabs: boolean;
  theme: ITheme;
  children: any;
  isGrid: boolean;
  minimizedProduct: IProductMinimizedData;
  units: unit[];
  preview_type: ProductPreviewTypes;
  type: string;
  bundleSetSelectedChildIndex?: (index: number | null) => void;
}

const ProductCard: React.FC<Props> = ({
  size,
  scrollableTabs,
  children,
  isGrid,
  minimizedProduct,
  units,
  preview_type,
  type,
  bundleSetSelectedChildIndex
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const { enableAddToCart } = useSellingMode();
  const ref = useInViewEffect(
    ([entry], observer) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
      }
      setIsVisible(entry.isIntersecting);
    },
    { threshold: 0 },
  );
  const smallBox = isSmallProductBox(size);
  const classname = smallBox
    ? `new-product-box-small${
        scrollableTabs && isGrid ? "-scrollable-tabs-grid" : ""
      }`
    : `new-product-box-large${
        scrollableTabs && isGrid ? "-scrollable-tabs-grid" : ""
      }`;

  return (
    <div ref={ref} className={classname}>
      {isVisible ? (
        <ProductBoxContextProvider
          product={minimizedProduct}
          units={units}
          preview_type={preview_type}
          type={type}
          bundleSetSelectedChildIndex={bundleSetSelectedChildIndex}
        >
          <EnableSellingTooltip enableSelling={enableAddToCart}>
            {children}
          </EnableSellingTooltip>
        </ProductBoxContextProvider>
      ) : (
        <div
          className={`skeleton-rect${scrollableTabs ? "-hor-product-box" : ""}`}
          style={{
            width: "100%",
            paddingTop: `${`max(${
              getProductBoxDefaultDimAndSpacing(size).height
            }px,100%`})`,
          }}
        ></div>
      )}
    </div>
  );
};

export default ProductCard;

const isSmallProductBox = (size: Size) =>
  [Size.small, Size.vertical_small].includes(size);
